module.exports = __webpack_public_path__ + "static/img/logo2.0301041b.png";